import { render } from "./KryptonCardHolderMail.vue?vue&type=template&id=f69269c2&lang=pug"
import script from "./KryptonCardHolderMail.vue?vue&type=script&lang=js"
export * from "./KryptonCardHolderMail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__